import { cn } from '../utils/cn.ts'

const variantLabels = {
  'rsvp-going': 'Going',
  'rsvp-cant-go': "Can't Go",
  invited: 'Invited',
  'payment-paid': 'Paid',
  'payment-unpaid': 'Unpaid',
} as const

type BadgeVariant = keyof typeof variantLabels

interface BadgeProps {
  variant: BadgeVariant
  className?: string
}

function Badge({ variant, className }: BadgeProps) {
  return (
    <span className={cn('badge', `badge-${variant}`, className)}>
      {variantLabels[variant]}
    </span>
  )
}

export { Badge, type BadgeProps }
